import { useTranslation } from "react-i18next";
import { Icon, Popup } from "semantic-ui-react";

import { CUSTOMER_TYPES } from "models";
import "modules/Dayplanner/components/AppointmentCard/components/CarQuickView/CarQuickView.scss";
import { getCustomerName, removeGenerationParam } from "utils/common";

import type { Appointment } from "models";
import type { ReactElement } from "react";

type CarQuickViewProps = {
  appointment: Appointment;
  popupTrigger: ReactElement;
};

export const CarQuickView = ({ appointment, popupTrigger }: CarQuickViewProps) => {
  const { t } = useTranslation();

  const content = (
    <div className="CarQuickView-container">
      <div className="CarQuickView-container__inner">
        <div className="car-image-container">
          {appointment.car_profile_picture ? (
            <img src={removeGenerationParam(appointment.car_profile_picture)} alt={t("v8_car_profile", "Car Profile")} className="car-image" />
          ) : (
            <Icon className="car" />
          )}
        </div>
        <div className="car-details">
          <div className="detail-item">
            <span className="detail-title">{t("v8_brand", "Brand")}</span>
            <span className="detail-value">{appointment.car_make}</span>
          </div>
          <div className="detail-item">
            <span className="detail-title">{t("v8_driver", "Driver")}</span>
            <span className="detail-value">{getCustomerName({ appointment, customerType: CUSTOMER_TYPES.Driver, showTitle: false, t: t })}</span>
          </div>
          <div className="detail-item">
            <span className="detail-title">{t("v8_model", "Model")}</span>
            <span className="detail-value">{appointment.car_model}</span>
          </div>
          <div className="detail-item">
            <span className="detail-title">{t("v8_contractor", "Contractor")}</span>
            <span className="detail-value">{getCustomerName({ appointment, customerType: CUSTOMER_TYPES.Contractor, showTitle: false, t: t })}</span>
          </div>
          <div className="detail-item">
            <span className="detail-title">{t("v8_dayplanner_car_vin_nr", "Vin number")}</span>
            <span className="detail-value">{appointment.vin_nr}</span>
          </div>
          <div className="detail-item">
            <span className="detail-title">{t("v8_owner", "Owner")}</span>
            <span className="detail-value">{getCustomerName({ appointment, customerType: CUSTOMER_TYPES.Owner, showTitle: false, t: t })}</span>
          </div>
        </div>
      </div>
    </div>
  );

  return <Popup trigger={popupTrigger} content={content} hoverable style={{ padding: "0 5px" }} />;
};
